export const JobPostingLocationTypes = {
    onSite: 'on-site',
    remote: 'remote',
    hybrid: 'hybrid',
} as const;
